import { useSyncExternalStore } from "react";

// Какие функции нейросети включены у этого пользователя. Приходят с сервера
// вместе с остальными настройками; лежат здесь, а не в пропсах, потому что
// нужны сразу в трёх далёких друг от друга местах — списке диалогов, поле
// ввода и карточке объявления. По умолчанию всё включено.
const DEFAULT_AI_PREFS = Object.freeze({
  aiIntentBadges: true,
  aiReplySuggestions: true,
  aiPhotoDescribe: true
});

// Язык быстрых действий ассистента («Перевод», «Ответ», «Анализ») — свой,
// от языка панели не зависит. По умолчанию русский.
export const normalizeQuickActionsLang = (value) => (String(value || "").trim().toLowerCase() === "en" ? "en" : "ru");

let current = { ...DEFAULT_AI_PREFS, aiQuickActionsLang: "ru" };
const listeners = new Set();

export const getAiPrefs = () => current;

export const setAiPrefs = (patch = {}) => {
  const next = { ...current };
  Object.keys(DEFAULT_AI_PREFS).forEach((key) => {
    if (patch[key] !== undefined) next[key] = patch[key] !== false;
  });
  if (patch.aiQuickActionsLang !== undefined) next.aiQuickActionsLang = normalizeQuickActionsLang(patch.aiQuickActionsLang);
  if (Object.keys(next).every((key) => next[key] === current[key])) return;
  current = next;
  listeners.forEach((listener) => { try { listener(); } catch (_) { /* слушатель сам разберётся */ } });
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useAiPrefs = () => useSyncExternalStore(subscribe, getAiPrefs, getAiPrefs);

export const AI_PREF_KEYS = Object.keys(DEFAULT_AI_PREFS);
